import BaseCollection from "nexia_mobile/models/base_collection";
import Device from "nexia_mobile/models/device";
import DeviceSorter from "nexia_mobile/models/device_sorter";
import { ResourceMap } from "nexia_mobile/framework/resource";

export default class DeviceCollection extends BaseCollection {
  model = Device;

  parse(attrs, ...args) {
    let devices = super.parse(attrs, ...args);
    return DeviceSorter.sort(this._recycleDevices(attrs, devices));
  }

  async _parseModelsAsync(attrs, ...args) {
    let devices = await super._parseModelsAsync(attrs, ...args);
    return DeviceSorter.sort(this._recycleDevices(attrs, devices));
  }

  _recycleDevices(attrs, devices) {
    let items = attrs.items || attrs.result;
    if (!items) {
      return devices;
    }

    // Jump through hoops to try to find an existing Device
    // model and just set attributes on it, if one is available.
    return devices.map((device, index) => {
      let deviceData = items[index];
      let existingDevice = ResourceMap.findByHref(device.id);
      if (existingDevice) {
        delete deviceData.id;
        return existingDevice.set(deviceData, { parse: true });
      } else {
        return device;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/models/device_collection.js